module.exports = __webpack_public_path__ + "img/private-key.eec5545f.svg";